import { Container, Reveal, Section, SectionHead } from '@nexa/ui';
import { useCopy } from '@/core/i18n';
import { ModuleCard } from './ModuleCard.tsx';

/**
 * `#modules` — 12 card, grid hairline (`template.html` dòng 788–811).
 *
 * Kỹ thuật hairline: `gap-px` trên nền `ink-100` cộng `overflow-hidden` — nền lộ ra qua khe CHÍNH
 * LÀ đường kẻ. Ở một cột, cùng kỹ thuật đó tự thành đường kẻ ngang liên tục mà không phải đổi gì;
 * đó là lý do chọn cách này thay vì border từng card, vốn cho kẻ đôi ở chỗ giáp nhau.
 *
 * Bậc cột 4 rồi 2 rồi 1 là `chốt` của skill, không phải `đo`: thiết kế chỉ có artboard 1440px và
 * không có một `@media` nào. 12 chia hết cho cả 4, 2 và 1 nên không bậc nào để lại hàng lẻ.
 *
 * Mồi `content-visibility` khai theo bậc trong `packages/ui/src/motion.css` — số ĐO, không phải
 * số đoán. Đặt sai chỉ làm thanh cuộn nhảy, không làm sai nội dung.
 */
export function ModulesSection() {
  const copy = useCopy();

  return (
    <Section id="modules" labelledBy="modules-head" cv className="nx-cv-modules">
      <Container width="content">
        {/*
          Khối đầu section CÓ `data-reveal` trong thiết kế (`template.html` dòng 790), ngang hàng
          với 12 card — tổng 13 khối reveal trong `#modules`. Thiếu lớp bọc này thì đầu section
          hiện ngay trong khi 12 card mới trôi vào, tức mất đúng nhịp mà thiết kế dựng.
        */}
        <Reveal>
          <SectionHead
            id="modules-head"
            eyebrow={copy.modules.eyebrow}
            heading={copy.modules.heading}
            lead={copy.modules.lead}
            // Thiết kế vẽ h2 của `#modules` bằng bậc 42px (`template.html:790`), không phải 40px.
            // Ở bề rộng thật của khối, 42 xuống 3 dòng còn 40 chỉ 2 — xem `--text-h2-large`.
            headingSize="h2-large"
          />
        </Reveal>

        <div className="mt-11 grid grid-cols-1 gap-px overflow-hidden rounded-card-lg border border-ink-100 bg-ink-100 md:grid-cols-2 xl:grid-cols-4">
          {copy.modules.cards.map((card) => (
            <Reveal key={card.title}>
              {/*
                Spread trọn thay vì liệt kê từng prop: `ModuleCardProps` khớp đúng hình dạng một
                phần tử của `copy.modules.cards`, và `tsconfig` bật `exactOptionalPropertyTypes`
                nên viết `beta={card.beta}` là LỖI BIÊN DỊCH — nó truyền `undefined` tường minh
                vào một prop khai là "có thể vắng mặt", hai thứ khác nhau dưới cờ đó.
              */}
              <ModuleCard {...card} />
            </Reveal>
          ))}
        </div>
      </Container>
    </Section>
  );
}
